import { useMutation } from "react-query";

import axios, { AxiosError } from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../constants/app.constants";
import type { CsvSurveyApiError, UploadCsvSurveysResponse } from "./useUploadCsvSurveys";

const API_BASE_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/pad-scenario`;

export interface UploadLegacyCsvSurveysParams {
  scenarioId: string;
  file: File;
  utmZone: string;
  datum: string;
  columnMapping?: Record<string, string>;
}

const uploadLegacyCsvSurveys = async ({
  scenarioId,
  file,
  utmZone,
  datum,
  columnMapping
}: UploadLegacyCsvSurveysParams): Promise<UploadCsvSurveysResponse> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("utmZone", utmZone);
  formData.append("datum", datum);

  if (columnMapping) {
    formData.append("columnMapping", JSON.stringify(columnMapping));
  }

  const url = `${API_BASE_URL}/${scenarioId}/survey/csv/upload`;
  const response = await axios.post<UploadCsvSurveysResponse>(url, formData);
  return response.data;
};

const useUploadLegacyCsvSurveys = () => {
  return useMutation<
    UploadCsvSurveysResponse,
    AxiosError<CsvSurveyApiError>,
    UploadLegacyCsvSurveysParams
  >(uploadLegacyCsvSurveys);
};

export default useUploadLegacyCsvSurveys;
